<template>
  <div>
    <div class="loading-overlay" v-if="isLoading">
      <div class="spinner-border text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="fromParentBtn"
      :btnClass="'btn-primary'"
      :btnToLink="'/race_series/add'"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>

    <h5>検索</h5>
    <div class="w100 mb-5">
      <div>
        <div class="row mb-1">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-6">申請状況</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <bs-select
                :options="app_flg_list"
                v-model="sprm.app_flg"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col text-center"></div>
          <div class="col text-center">
            <bs-button
              :btnClass="'btn-primary'"
              @to_click_event="search_entry_setting()"
              >条件で検索</bs-button
            >
          </div>
          <div class="col text-end">
            <bs-button
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="clear"
              >検索条件クリア</bs-button
            >
          </div>
        </div>
      </div>
    </div>

    <div
      class="w100"
      v-if="
        typeof entry_setting_list === 'object' &&
        Object.keys(entry_setting_list).length > 0
      "
    >
      <table class="table">
        <thead>
          <tr>
            <th style="width: 7%">状況</th>
            <th style="width: 10%">主催者コード</th>
            <th style="width: auto">主催者名</th>
            <th colspan="1" style="width: 12%">action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in entry_setting_list" :key="list.id">
            <td>{{ get_list_label(list.app_flg, app_flg_list) }}</td>
            <td>{{ list?.owner_no }}</td>
            <td>{{ list?.owner_label }}</td>
            <td>
              <bs-button
                :btnClass="'btn-light btn-sm btn-outline-secondary'"
                @to_click_event="handleClick(list.id)"
                >詳細</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-8">
          <bs-page-nav
            :pager_key="'entry_setting_list'"
            @to_click_event="pageAction"
          ></bs-page-nav>
        </div>
      </div>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
// import Common from '../common/common'
import BsSelect from '../../atoms/BsSelect.vue'
import BsButton from '../../atoms/BsButton.vue'
import BsPageNav from '../../molecules/BsPageNav.vue'
import config from '../../../const'

export default {
  name: 'EntrySettingList',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: '申請データ一覧',
      fromParentBtn: '',
      entry_setting_obj: [],
      sprm: {
        app_flg: '',
        lisence_no: '',
        like_name: ''
      },
      mail_flg_list: [
        {
          key: 0,
          label: '変更しない'
        },
        {
          key: 1,
          label: '変更する'
        }
      ],
      app_flg_list: [
        {
          key: 0,
          label: '申請'
        },
        {
          key: 1,
          label: '完了'
        }
      ],
      page: 0,
      page_limit: 10,
      isLoading: false
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsMsgAlert,
    BsSelect,
    BsPageNav
  },
  computed: {
    ...mapState({}),

    get_list_label: function () {
      return function (key, lists) {
        // if (key === '0') return '未選択'
        if (
          typeof lists === 'object' &&
          typeof lists.find(list => list.key == key) === 'object'
        ) {
          return lists.find(list => list.key == key).label
        }
        return key
      }
    },
    entry_setting_list: function () {
      const lists = [...this.entry_setting_obj]
      return lists
    }
  },

  async created() {
    // await this.loadEntrySettingList()
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = 'エントリーシステム申請データ一覧です'
  },

  methods: {
    clear() {
      const params = { ...this.sprm }
      if (typeof params === 'object') {
        Object.keys(params).forEach(sprm_key => {
          params[sprm_key] = ''
        })
      }
      this.sprm = params
      this.$store.dispatch('setSearchParam', {
        data: params,
        target: 'license_cd'
      })
    },
    async search_entry_setting() {
      this.isLoading = true
      try {
        await new Promise(resolve => setTimeout(resolve, 500))
        this.page = 0
        await this.loadEntrySettingList()
      } finally {
        this.isLoading = false
      }
    },
    async pageAction(page) {
      this.page = page
      await this.loadEntrySettingList()
    },

    async loadEntrySettingList() {
      const params = {}
      params['stat'] = [1]
      if (typeof this.sprm === 'object') {
        Object.keys(this.sprm).forEach(param_key => {
          if (this.sprm[param_key]) {
            params[param_key] = this.sprm[param_key]
          }
        })
      }
      params['pagelimit'] = 30
      params['list_search'] = 1
      if (this.page >= 0) params['p'] = this.page
      // params['pageorder'] = 'mfj_member_entry_setting_member.id'
      // params['pageorder'] = this.page_order;
      params['pagesort'] = 'ASC'
      this.$store.dispatch('setSearchParam', {
        data: params,
        target: 'entry_setting_list'
      })
      console.log('loadEntrySettingList params', params)
      await this.basicPosts_S(
        config.BASE_API_URL + '/entry_owner_setting/lists',
        params
      )
        .then(async response => {
          console.log('loadEntrySettingList response', response)
          this.entry_setting_obj =
            response.data && response.data.body ? response.data.body : []

          this.$store.dispatch('setSearchParam', {
            data: params,
            target: 'entry_setting_list'
          })
          const setPageData = {}
          setPageData.data =
            response.data && response.data.pager ? response.data.pager : {}
          setPageData.target = 'entry_setting_list'
          this.$store.dispatch('setPager', setPageData)
        })
        .catch(async err => {
          console.log(err)
          this.entry_setting_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    handleClick(target) {
      this.$router.push({ path: '/system_entry/' + target + '/' })
    }
  }
}
</script>
